import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { BreadcrumbComponent } from "../../../../common/components";
import { routes } from "../../../../constants/routes";
import LeftPanel from "./create-rule-leftPanel";
import RightPanel from "./create-rule-right-panel";
import { createRuleValidationSchema } from "./validations";
const CreateAssignmentRule = () => {
    const breadcrumbLink = [
        { label: "Lead Assignment", link: `${routes.ASSIGNMENTRULES}` },
        { label: "Assignment Rules", link: `${routes.ASSIGNMENTRULES}` },
        { label: "Create New Rule", link: "#", handleClick: () => { } },
    ];

    const initialValues = {
        ruleName: "",
        isActive: "Active",
        geographyParam: "",
        country: "",
        state: "",
        city: "",
        zipcode: "",
        conditionType: "And",
        productType: [],
    };

    const formatData = (data:any) => {
        return {
            ruleName: data?.ruleName,
            isActive: data?.isActive === "Active" ? true : false,
            geographyParam: data?.geographyParam,
            geographyValue: data?.geographyParam?.split(","),
            conditionType: data?.conditionType,
            productType: [data?.productType]
        }
    }

    const handleSubmit = (values: typeof initialValues) => {
        const payload = formatData(values);
    };

    return (
        <div className="create-new-rule-main-wrapper">
            <div className="breadcrumb-wrapper">
                <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
            </div>

            <Formik
                initialValues={initialValues}
                validationSchema={createRuleValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                // validateOnChange
                // validateOnBlur
                
            >
                {(formik) => (
                    <form onSubmit={formik.handleSubmit}>
                        <div className="create-new-rule-body-wrapper">
                            <div className="left-panel">
                                <LeftPanel />
                            </div>
                            <div className="right-panel">
                                <RightPanel />
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default CreateAssignmentRule;